/**
 * For an app whose pages are the hash of the address (`/#/firms`): the address a path without
 * one stands for. A link or a typed `/firms` otherwise showed the start page and said nothing;
 * now it leads to `#/firms` - that page, or the app's „not found“. The query stays where it was
 * (the sign-in marks a failed attempt there). `null` when the address already is the app's.
 */
export function hashRouteOf({ pathname, search, hash, }) {
    if (pathname === '/' || pathname === '/index.html')
        return null;
    // An address with both keeps its hash: that is the page asked for.
    if (hash.startsWith('#/'))
        return `/${search}${hash}`;
    const path = pathname.replace(/\/+$/, '');
    return `/${search}#${path}`;
}
//# sourceMappingURL=hash-route.js.map